var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgStarter = function SvgStarter(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#98D393",
    d: "M18.22 14.155c-.194.168-.367.368-.555.546-1.826 1.731-4.43 3.133-6.99 3.232l-.259.01h-.252C7.073 17.863 3.959 16.075 2 13.742c-.324-.386-.976-1.241-.998-1.742-.02-.444.507-1.184.777-1.532 1.597-2.058 4.31-3.825 6.883-4.315 3.628-.691 7.05 1.056 9.513 3.59.024.025.016.053.062.032 0 0 1.14 1.746-.015 4.381"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4EA254",
    d: "m22.498 7.828-.914 4.14.914 4.139v.147c-.09.447-.643.631-1.006.371l-3.271-2.47c1.155-2.635.015-4.381.015-4.381l3.256-2.465c.33-.265.951-.06 1.006.372.006.045-.004.1 0 .147"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.004,
    d: "M5.433 10.318a.977.977 0 1 0 1.955.002.977.977 0 0 0-1.955-.002Z"
  })));
};
export default SvgStarter;